export const envConfig = {
    development: {
        API_URL: 'https://openbankinghub.dev.aceve.cloud/api/v1',
        //API_URL: 'https://localhost:8080/api/v1',
        I18N_URL: 'https://translations.staging.hvdhub.com/api/Translations/Json/OpenBanking',
        redirectUri: 'https://openbankingfe.dev.aceve.cloud/bank-connected',
        //redirectUri: 'http://localhost:3000/bank-connected',
    },
    staging: {
        API_URL: 'https://openbankinghub.staging.aceve.cloud/api/v1',
        I18N_URL: 'https://translations.staging.hvdhub.com/api/Translations/Json/OpenBanking',
        redirectUri: 'https://openbankingfe.staging.aceve.cloud/bank-connected',
    },
    production: {
        API_URL: 'https://openbankinghub.aceve.cloud/api/v1',
        I18N_URL: 'https://translations.staging.hvdhub.com/api/Translations/Json/OpenBanking',
        redirectUri: 'https://openbanking.aceve.cloud/bank-connected',
    }
};

// You already have this function, which matches your example
// You already have this function, which matches your example
export const getCurrentEnv = () => {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname.includes('dev')) {
        return 'development';
    } else if (hostname.includes('staging')) {
        return 'staging';
    }
    return 'production';
};

// Now add specific exports for each API URL
const currentEnv = getCurrentEnv();

export const apiUrl = envConfig[currentEnv].API_URL;

// Keep your existing function for URL parameters
export const getUrlParams = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return {
        token: queryParams.get('token')
    };
};